import {
    Form,
    Input,
    ModalProps,
    FormProps,
    Modal,
    useSelect,
} from "@pankod/refine-antd";
import { useGetIdentity } from "@pankod/refine-core";
import { useUserContext } from "context/user";
import { createUserHistory } from "gql/mutations";
import { ITeacherLevel } from 'interfaces'

type EditCheckListProps = {
    modalProps: ModalProps;
    formProps: FormProps;
};

export const EditCheckList: React.FC<EditCheckListProps> = ({
    modalProps,
    formProps,
}) => {
    const { data: user } = useGetIdentity();
    const { userRole } = useUserContext()
    const onFinish = async (values: any) => {
        return (
            formProps.onFinish &&
            formProps.onFinish({
                ...values,
                updated_by: user?.id

            })
        )
    }
    return (
        <Modal {...modalProps} title="Edit Check list">
            <Form {...formProps} layout="vertical" onFinish={async values => {
                let response = await onFinish(values).then((response: any) => {
                    if (response) {
                        createUserHistory('check_lists', 'edit', response?.data?.id, user?.id, userRole)
                    }

                })

                return response
            }}
            >
                <Form.Item
                    label="Check List"
                    name="name"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item name="updated_by"
                    initialValue={user?.id}>
                    <Input type="hidden" />
                </Form.Item>

            </Form>
        </Modal >
    );
};
